import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryKindCustomTransactionLocationEmptyError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.inventory.kind.validation.custom-transaction-location.is-empty');
    }
}
